import React from "react";

// Stylised world map with Africa highlighted — pure SVG, no external asset.
// Coordinates are simplified continent silhouettes optimized for a decorative,
// institutional feel (not a cartographically precise map).
export const WorldMap = () => {
  return (
    <svg
      viewBox="0 0 800 400"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto"
      aria-hidden
    >
      <defs>
        <pattern id="dots" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse">
          <circle cx="1.2" cy="1.2" r="1" fill="#1e293b" />
        </pattern>
        <pattern id="dotsBlue" x="0" y="0" width="7" height="7" patternUnits="userSpaceOnUse">
          <circle cx="1.2" cy="1.2" r="1.1" fill="#0089C8" />
        </pattern>
        <linearGradient id="glow" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#0089C8" stopOpacity="0.35" />
          <stop offset="1" stopColor="#044D29" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Faint grid */}
      <g opacity="0.35">
        {Array.from({ length: 20 }).map((_, i) => (
          <line key={`h${i}`} x1="0" x2="800" y1={i * 20} y2={i * 20} stroke="#101018" />
        ))}
        {Array.from({ length: 40 }).map((_, i) => (
          <line key={`v${i}`} x1={i * 20} x2={i * 20} y1="0" y2="400" stroke="#101018" />
        ))}
      </g>

      {/* North America */}
      <path
        d="M60,110 L150,90 L200,120 L210,170 L170,200 L120,205 L90,175 Z"
        fill="url(#dots)"
        stroke="#1f2937"
        strokeWidth="0.6"
      />
      {/* South America */}
      <path
        d="M195,215 L235,220 L245,260 L225,320 L200,340 L180,315 L175,265 Z"
        fill="url(#dots)"
        stroke="#1f2937"
        strokeWidth="0.6"
      />
      {/* Europe */}
      <path
        d="M370,105 L440,95 L455,130 L430,150 L385,145 L365,125 Z"
        fill="url(#dots)"
        stroke="#1f2937"
        strokeWidth="0.6"
      />
      {/* Asia */}
      <path
        d="M460,90 L640,85 L700,120 L710,170 L640,200 L560,190 L510,160 L470,140 Z"
        fill="url(#dots)"
        stroke="#1f2937"
        strokeWidth="0.6"
      />
      {/* Oceania */}
      <path
        d="M640,285 L710,280 L720,315 L680,325 L645,315 Z"
        fill="url(#dots)"
        stroke="#1f2937"
        strokeWidth="0.6"
      />

      {/* Africa — highlighted */}
      <g>
        <path
          d="M395,165 L455,160 L490,190 L500,230 L490,280 L455,325 L420,340 L395,320 L380,285 L370,240 L375,205 Z"
          fill="url(#dotsBlue)"
          stroke="#0089C8"
          strokeWidth="1.2"
        />
        <path
          d="M395,165 L455,160 L490,190 L500,230 L490,280 L455,325 L420,340 L395,320 L380,285 L370,240 L375,205 Z"
          fill="url(#glow)"
        />

        {/* Highlight points on Africa */}
        {[
          [430, 200],
          [455, 235],
          [430, 260],
          [415, 290],
          [400, 220],
          [445, 285],
        ].map(([cx, cy], i) => (
          <g key={i}>
            <circle cx={cx} cy={cy} r="6" fill="#FF6B35" opacity="0.15" />
            <circle cx={cx} cy={cy} r="2.5" fill="#FF6B35" />
          </g>
        ))}
      </g>

      {/* Label */}
      <g transform="translate(500, 250)">
        <line x1="0" y1="0" x2="60" y2="0" stroke="#0089C8" strokeWidth="1" />
        <text x="65" y="4" fill="#0089C8" fontSize="10" fontFamily="Outfit, sans-serif" letterSpacing="2">
          AFRICA — PRIMARY FOOTPRINT
        </text>
      </g>
    </svg>
  );
};

export default WorldMap;
